import { WorkspaceWindowTypeEnum } from '@mark43/cad-api';
import { useWorkspaceWindowType } from './use-workspace-window-type';

export function usePanelsPermittedInWindow(): boolean {
    const workspaceWindowType = useWorkspaceWindowType();
    return WorkspaceWindowTypeEnum[workspaceWindowType].panelsPermitted;
}
